/**
 * An object containing card filter properties
 */
var CardFilter = /** @class */ (function () {
    function CardFilter() {
    }
    return CardFilter;
}());
export { CardFilter };
//# sourceMappingURL=card-filter.js.map